import {Event} from '@sentry/react';

export const beforeSend = (event: Event): PromiseLike<Event | null> | Event | null => {
  event.fingerprint = [Date.now().toString()];
  return event;
};
